<template>
    <div class= "footer">

       <!-- Copyright -->
<div class="footer-copyright text-center py-3">© 2020 Copyright:
  <a href=" https://github.com/BulelaG"> Bulela Gomoshe</a>
</div>
<!-- Copyright -->

    </div>
</template>

<script>
export default {
    name: 'Footer'
}
</script>
<style scoped>

  #footer {
            position: fixed;
            padding: 10px 10px 0px 10px;
            bottom: 0;
            width: 100%;
            /* Height of the footer*/ 
            height: 30px;
            background: rgb(177, 177, 177);
        }
div{background-color:#b1b1b1;


}
</style>



